import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore'
import { db } from '@/firebase'

function getTodayKey() {
  const today = new Date()
  const yyyy = today.getFullYear()
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const dd = String(today.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export async function rewardUser(store, reason, meta = {}, showToast) {
  const user = store.getters.getUser
  if (!user || !user.accessToken) return

  const rewardMap = {
    writePost: Number(import.meta.env.VITE_REWARD_COMMENT),
    writeComment: Number(import.meta.env.VITE_REWARD_COMMENT),
    share: Number(import.meta.env.VITE_REWARD_SHARE),
    refJoin: Number(import.meta.env.VITE_REWARD_FRIEND_IN),
    dailyCheckin: Number(import.meta.env.VITE_REWARD_VISIT),
  }

  const amount = rewardMap[reason]
  if (!amount) return

  const uid = user.accessToken

  if (reason === 'refJoin') {
    const { referredUser, referrer } = meta
    if (!referredUser || !referrer) return

    const refJoinRef = doc(db, 'rewardLogs', referrer, 'refJoin', referredUser)
    const alreadyRewarded = await getDoc(refJoinRef)
    if (alreadyRewarded.exists()) return // 이미 지급된 경우

    // 공유자에게 보상 지급
    // 먼저 공유자가 존재하는지 체크
    const refUserSnap = await getDoc(doc(db, 'users', referrer))
    if (!refUserSnap.exists()) return
    console.log('공유자에게 보상을 지급합니다.')

    await store.dispatch('chargeLydia', {
      userName: '공유',
      accessToken: referrer,
      amount,
      chargeInfo: JSON.stringify({ reason, referredUser }),
    })

    // 지급 내역 기록
    await setDoc(refJoinRef, { rewardedAt: new Date().toISOString() })
    return
  }

  const today = getTodayKey()
  const logRef = doc(db, 'rewardLogs', uid, 'daily', today)
  let log = {}
  const snapshot = await getDoc(logRef)
  if (snapshot.exists()) {
    log = snapshot.data()
  }

  // 조건 체크
  if (
    (reason === 'writePost' || reason === 'writeComment') &&
    (log.write ?? 0) >= 3
  ) {
    console.log('일일 글쓰기 보상 한도 횟수(3회)에 도달했습니다.')
    return // 하루 3회 초과
  }

  if (reason === 'dailyCheckin' && log.dailyCheckin) {
    console.log('일일 출석체크 보상 한도 횟수(1회)에 도달했습니다.')
    return // 이미 출석
  }

  // 보상 지급
  // Firestore에서 불러 온 데이터는 JSON화 과정이 필요하다.
  const chargeInfoRaw = { reason, ...meta }
  const chargeInfo = JSON.parse(JSON.stringify(chargeInfoRaw))
  await store.dispatch('chargeLydia', {
    userName: user.name,
    accessToken: user.accessToken,
    amount,
    chargeInfo,
  })

  // 기록 업데이트
  const update = {}
  if (reason === 'writePost' || reason === 'writeComment') {
    update.write = (log.write ?? 0) + 1
  }
  if (reason === 'dailyCheckin') {
    update.dailyCheckin = true
  }
  update.updatedAt = serverTimestamp()

  if (snapshot.exists()) {
    await updateDoc(logRef, update)
  } else {
    await setDoc(logRef, update)
  }

  if (typeof showToast === 'function') {
    showToast(`${amount}LYD 보상이 지급되었습니다.`)
  }
  console.log(`${amount}LYD 보상이 지급되었습니다.`)
}
